import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { environment } from "../environments/environment";
import { flatMap } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" })
};
var SignupService = /** @class */ (function () {
    function SignupService(http) {
        this.http = http;
        this.sessionsUrl = "/api/sessions";
        this.registrationsUrl = "/api/registrations";
        this.industriesUrl = "/api/industries";
        this.uploadUrl = "/api/logos";
        this.exitSurveyUrl = "/api/exitsurvey";
        this.peopleUrl = "/api/people";
        this.errorNoLocalStorage = new BehaviorSubject(false);
        this.apiUrl = environment.apiUrl;
    }
    // browser allow to disable localStorage, so we check if localStorage operations were successful
    SignupService.prototype.checkForLocalStorage = function () {
        try {
            localStorage.setItem("test", "passed");
            localStorage.removeItem("test");
        }
        catch (error) {
            // no local storage, let listeners know
            this.errorNoLocalStorage.next(true);
        }
    };
    SignupService.prototype.checkIfEmailAlreadyTaken = function (email) {
        var url = this.createUrl(this.peopleUrl) + "?email=" + email;
        return this.http.get(url, {});
    };
    SignupService.prototype.getStoredValues = function () {
        if (this.errorNoLocalStorage.value)
            return {};
        return Object.keys(localStorage).reduce(function (obj, key) {
            obj[key] = localStorage.getItem(key);
            return obj;
        }, {});
    };
    SignupService.prototype.updateStore = function (values) {
        if (this.errorNoLocalStorage.value || !values)
            return;
        Object.keys(values).forEach(function (key) {
            if (values[key])
                localStorage.setItem(key, values[key]);
        });
    };
    SignupService.prototype.deleteFromStore = function (key) {
        if (this.errorNoLocalStorage.value || !key)
            return;
        var storedValues = this.getStoredValues();
        if (storedValues[key])
            localStorage.removeItem(key);
    };
    SignupService.prototype.uploadFile = function (fileData) {
        var data = new FormData();
        if (fileData.data)
            data.append("data", JSON.stringify(fileData.data));
        data.append("logo", fileData.logo);
        return this.http.post(this.createUrl(this.uploadUrl), data);
    };
    SignupService.prototype.initSession = function (email) {
        var _this = this;
        return this.checkIfEmailAlreadyTaken(email).pipe(flatMap(function (emailDto) {
            if (emailDto.emailInUse) {
                throw new GenericError("EMAIL_ALREADY_EXISTS_IN_PLATFORM", "This business is already signed up");
            }
            else {
                return _this.http.post(_this.createUrl(_this.sessionsUrl), { email: email }, httpOptions);
            }
        }));
    };
    SignupService.prototype.verifySession = function (session) {
        var queryStringEmail = (session && session.email) ? "email=" + encodeURIComponent(session.email) + "&" : "";
        return this.http.get(this.createUrl(this.sessionsUrl) + "?" + queryStringEmail + "passcode=" + session.passcode, httpOptions);
    };
    SignupService.prototype.updateRegistration = function (registration) {
        return this.http.put(this.createUrl(this.registrationsUrl), registration, httpOptions);
    };
    SignupService.prototype.getRegistration = function (session) {
        var queryStringEmail = (session && session.email) ? "email=" + encodeURIComponent(session.email) + "&" : "";
        var queryStringPasscode = (session && session.passcode) ? "passcode=" + session.passcode : "";
        return this.http.get(this.createUrl(this.registrationsUrl) + "?" + queryStringEmail + queryStringPasscode, httpOptions);
    };
    SignupService.prototype.finishRegistration = function (session) {
        var data = Object.assign(session, { fields: { registrationInitiated: true } });
        return this.http.put("" + this.createUrl(this.registrationsUrl), data, httpOptions);
    };
    SignupService.prototype.getIndustries = function () {
        return this.http.get("" + this.createUrl(this.industriesUrl));
    };
    SignupService.prototype.submitExitSurvey = function (payload) {
        return this.http.post("" + this.createUrl(this.exitSurveyUrl), payload);
    };
    SignupService.prototype.createUrl = function (url) {
        if (this.apiUrl) {
            var endsWithSlash = this.apiUrl.endsWith("/");
            var root = endsWithSlash ? this.apiUrl.substring(0, this.apiUrl.length - 1) : this.apiUrl;
            return root + url;
        }
        return url;
    };
    SignupService.ngInjectableDef = i0.defineInjectable({ factory: function SignupService_Factory() { return new SignupService(i0.inject(i1.HttpClient)); }, token: SignupService, providedIn: "root" });
    return SignupService;
}());
export { SignupService };
var GenericError = /** @class */ (function (_super) {
    tslib_1.__extends(GenericError, _super);
    function GenericError(error, message) {
        var _this = _super.call(this, message) || this;
        _this.error = {};
        _this.name = "GenericError";
        _this.error = { "error": error };
        return _this;
    }
    return GenericError;
}(Error));
